// src/controllers/DietasController.js
const state = {
    materiasSeleccionadas: [],
    detallesPorMateria: {},
    restriccionesPorMateria: {},
};

export const DietasController = {
    snapshot() {
        return JSON.parse(JSON.stringify(state));
    },

    getSeleccionadas() {
        return [...state.materiasSeleccionadas];
    },

    getDetalleMateria(id) {
        return state.detallesPorMateria[id] || null;
    },

    getRestriccionMateria(id) {
        return state.restriccionesPorMateria[id] || null;
    },

    getRestricciones() {
        return { ...state.restriccionesPorMateria };
    },

    setSeleccionadas(arr) {
        state.materiasSeleccionadas = Array.isArray(arr) ? [...arr] : [];
        const validIds = new Set(state.materiasSeleccionadas.map(m => String(m.id)));
        Object.keys(state.restriccionesPorMateria).forEach(id => {
            if (!validIds.has(String(id))) delete state.restriccionesPorMateria[id];
        });
    },

    setDetalleMateria(id, detalle) {
        state.detallesPorMateria[id] = { ...(detalle || {}) };
    },

    // ⬇️ Actualizado: soporta min/max en kg y en %MS
    setRestriccionMateria(id, data) {
        const toNum = (v) => {
            if (v === "" || v === null || v === undefined) return NaN;
            const n = Number(String(v).replace(",", "."));
            return Number.isFinite(n) ? n : NaN;
        };

        const costo = toNum(data?.costo);

        const minKg = (() => {
            const v = toNum(data?.minKg ?? data?.min_kg ?? data?.minAsFed ?? data?.min);
            return Number.isFinite(v) && v >= 0 ? v : "";
        })();
        const maxKg = (() => {
            const v = toNum(data?.maxKg ?? data?.max_kg ?? data?.maxAsFed ?? data?.max);
            return Number.isFinite(v) && v >= 0 ? v : "";
        })();

        // NUEVO: % de MS (si el paso 4 lo envía)
        const minPctMS = (() => {
            const v = toNum(data?.minPctMS ?? data?.min_pct_ms ?? data?.minMSpct);
            return Number.isFinite(v) && v >= 0 ? v : "";
        })();
        const maxPctMS = (() => {
            const v = toNum(data?.maxPctMS ?? data?.max_pct_ms ?? data?.maxMSpct);
            return Number.isFinite(v) && v >= 0 ? v : "";
        })();

        state.restriccionesPorMateria[id] = {
            costo: Number.isFinite(costo) && costo >= 0 ? costo : 0,
            minKg,
            maxKg,
            ...(minPctMS !== "" ? { minPctMS } : {}),
            ...(maxPctMS !== "" ? { maxPctMS } : {}),
        };
    },

    clear() {
        state.materiasSeleccionadas = [];
        state.detallesPorMateria = {};
        state.restriccionesPorMateria = {};
    },
};

export default DietasController;